import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {AuthService} from '../../../services/auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../../services/loader/loader.service';

import {MetaTitle} from '../../../decorator/meta-title';
import {VersionService} from '../../../services/version/version.service';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login.component.scss'
})
@MetaTitle('Login')
export class LoginComponent implements OnInit {

  loginForm = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    rememberMe: new FormControl(false)
  })

  redirectUrl: string = '/';
  errorMessage: null = null;

  constructor(
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private versionService: VersionService
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.redirectUrl = params['redirect'] ?? '/';

      if (this.auth.isLogged()) {
        this.router.navigateByUrl(this.redirectUrl).then();
      }
    });

    if (this.auth.isStoredSession()) {
      this.loginForm.get('rememberMe')?.patchValue(true);
    }

    this.loader.stopLoading();
  }

  onSubmit(): void {
    this.errorMessage = null;

    if (!this.loginForm.value.email || !this.loginForm.value.password) {
      return;
    }

    this.loader.startLoading();

    this.auth.login(
      this.loginForm.value.email,
      this.loginForm.value.password,
      this.loginForm.value.rememberMe ?? true
    ).subscribe({
      next: (): void => {
        this.loader.stopLoading();
        // Redirect is automatically done in ngOnInit
      },
      error: (error): void => {
        this.loader.stopLoading();
        this.errorMessage = error;
      }
    });
  }

  getVersion(): string {
    return this.versionService.getFullVersion();
  }
}
